export const GET_NOTIFICATION_LIST_DATA ='GET_NOTIFICATION_LIST_DATA'
export const CLEAR_NOTITFICATION_LIST_DATA='CLEAR_NOTIFICATION_LIST_DATA'
export const UPDATE_NOTIFICATION_LIST_DATA='UPDATE_NOTIFICATION_LIST_DATA'
export const UPDATE_NOTIFICATION_LIST_ALL_DATA='UPDATE_NOTIFICATION_LIST_ALL_DATA'
export const SHOW_NEW_NOTIFICATION_DOT='SHOW_NEW_NOTIFICATION_DOT'
export const REMOVE_READ_NOTIFICATIONS='REMOVE_READ_NOTIFICATIONS'